module.exports = __webpack_public_path__ + "catalog/items/livingroom/CoffeeTable/CoffeeTable.svg";